import { motion } from "framer-motion";
import { Skill } from "../data/skills";
import { container, itemUp, skllsItemUp } from "../Utils/framerMotionVariants";

const SkillSet: React.FC<{ skill: Skill }> = ({ skill }) => {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={container}
    >
      <div className="mt-8">
        <motion.h3 className="font-medium" variants={itemUp}>
          {skill.category}
        </motion.h3>

        <div className="mt-5 flex flex-wrap gap-2">
          {skill.skillSet.map((sk) => (
            <motion.span
              variants={skllsItemUp}
              key={sk}
              whileHover={{ scale: 1.05 }}
              className="text-sm px-3 py-2 bg-white/10 border border-white/20 rounded-md shadow-sm"
            >
              {sk}
            </motion.span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default SkillSet;
